/**
 * XNGAGE CONFIDENTIAL
 * __________________________
 *
 * Copyright (C) 2021 Xngage - All Rights Reserved
 *
 * All code or information contained herein is, and remains the
 * property of Xngage LLC and its customers. The intellectual
 * and technical concepts contained are proprietary to Xngage LLC
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Xngage LLC.
 */

import {
    ApiHandler,
    HasOnError,
    HasOnSuccess,
    replaceInChain
} from "@insite/client-framework/HandlerCreator";
import {
    addPaymentProfile as addPaymentProfileApi,
    AddPaymentProfileApiParameter,
} from "@insite/client-framework/Services/AccountService";
import { chain, RequestDataFromApi } from "@insite/client-framework/Store/Data/PaymentProfiles/Handlers/AddPaymentProfile";
import { AccountPaymentProfileModel } from "@insite/client-framework/Types/ApiModels";

type HandlerType = ApiHandler<AddPaymentProfileApiParameter & HasOnSuccess & HasOnError<boolean | undefined>, AccountPaymentProfileModel, { error?: boolean }>;

export const CustomRequestDataFromApi: any = async (props: any) => {
    try {
        props.apiResult = await addPaymentProfileApi(props.parameter);
    } catch (e) {
        props.error = true;
        return false;
    }
};

replaceInChain(chain, RequestDataFromApi, CustomRequestDataFromApi);
